import { print } from "graphql";
import { Client } from "graphql-ws";
import {
	getLocationByIdOfflineQueryKey,
	getLocationByIdQueryKey,
	syncLocationById,
} from "./use-get-location-by-id";
import {
	getOperationalLocationsOfflineQueryKey,
	getOperationalLocationsQueryKey,
} from "./use-get-operational-locations";
import {
	GetOperationalLocationsQuery,
	SubscribeToVenueLocationsDocument,
	SubscribeToVenueLocationsSubscription,
} from "~/types/__generated/gql/graphql";
import { queryClient } from "~/providers/query-provider";

void (
	/* GraphQL */ `
		subscription SubscribeToVenueLocations {
			subscribeToVenueLocations {
				type
				id
				payload {
					_id
					created_at
					updated_at
				}
			}
		}
	`
);

export const subscribeToVenueLocations = async (client: Client) => {
	const subscription = client.iterate<SubscribeToVenueLocationsSubscription>({
		query: print(SubscribeToVenueLocationsDocument),
	});
	for await (const result of subscription) {
		if (result.data) {
			const { type, payload } = result.data.subscribeToVenueLocations;
			switch (type) {
				case "create":
				case "update":
					if (payload) {
						void syncLocationById(payload._id, {
							updatedAt: payload.updated_at,
						});
					}
					void queryClient.invalidateQueries({
						queryKey: getOperationalLocationsQueryKey(),
						exact: true,
					});
					break;
				case "delete": {
					if (payload) {
						queryClient.removeQueries({
							queryKey: getLocationByIdQueryKey(payload._id),
							exact: true,
						});
						queryClient.removeQueries({
							queryKey: getLocationByIdOfflineQueryKey(payload._id),
							exact: true,
						});
						const removeLocation = (
							locations: GqlResultOf<GetOperationalLocationsQuery> | undefined,
						) => locations?.filter((l) => l._id !== payload._id);
						queryClient.setQueryData(
							getOperationalLocationsQueryKey(),
							removeLocation,
						);
						queryClient.setQueryData(
							getOperationalLocationsOfflineQueryKey(),
							removeLocation,
						);
					}
					void queryClient.invalidateQueries({
						queryKey: getOperationalLocationsQueryKey(),
						exact: true,
					});
					break;
				}
			}
		}
	}
};
